/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsIfaApproval204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsIfaApproval505Schema = z.any();

export const optionsIfaApprovalMutationResponseSchema = z.lazy(() => optionsIfaApproval204Schema);
